<template>
  <div class="driver-overview-wrap">
    <v-row no-gutters>
      <v-col cols="12" class="d-flex">
        <div class="wrap-title">Driver analysis</div>
        <div class="info-icon pt-4" name="tippy01"
        ><i class="las la-info-circle ls-4"></i></div>
        <tippy to="tippy01"
          interactive="true"
          theme="light amara"
          class="am-tool"
          :allowHTML="true"
          arrow
          placement="right"
        >
          <h3><b>Driver analysis</b></h3>
          <p>
            Drivers measure how satisfied employees are with the
            culture, leadership, work life balance and responsibilities
            that make up their experience at work.
          </p>
          <v-btn class="am-tool-btn" small color="red">
            +&nbsp;Read more&nbsp;(Coming soon...)
          </v-btn>
        </tippy>
        <!-- <button name="tippy01">Tooltip using component</button> -->
      </v-col>
      <v-col cols="12" class="pb-4">
        <div class="driver-sub-wrap">
          <span class="driver-sub-text">
            Average score of all key engagement drivers.
          </span>
          <span class="driver-action" @click="viewDrivers">
            <!-- <v-btn text icon class="" small color="primary"> -->
              <!-- <span> -->
                <v-icon class="ml-n1" color="primary">las la-external-link-alt</v-icon>
              <!-- </span> -->
              <span class="font-weight-bold">View more</span>
            <!-- </v-btn> -->
          </span>
        </div>
      </v-col>
    </v-row>
    <div v-if="dashboardData.drivers_analysis">
      <v-row >
        <v-col cols="12" sm="3" md="4" lg="2"
          v-for="(driver, index) in dashboardData.drivers_analysis"
          :key="index"
        >
          <div class="driver-overview-card" @click="viewDriverCard(driver.driver_name)">
            <div class="driver-donut">
              <v-progress-circular
                :rotate="270"
                :size="80"
                :width="10"
                :value="driver.driver_average*2*10"
                color="primary"
              >
                <span class="driver-score" v-if="driver.driver_average">
                  {{driver.driver_average.toFixed(1)}}
                </span>
                <span class="driver-score" v-else>
                  0.0
                </span>
              </v-progress-circular>
            </div>
            <div class="driver-title">
              <span v-if="driver.driver_name">
                <!-- {{driver.driver_name.replace(/([a-z0-9])([A-Z])/g, '$1 $2').toLowerCase()}} -->
                {{driver.driver_name.replace(/([A-Z])/g, ' $1')}}
              </span>
              <span v-else>
                --
              </span>
            </div>
            <div class="driver-footer">
              <div class="driver-stats s-negative">
                <span v-if="driver.negative_responses">{{driver.negative_responses}}</span>
                <span v-else>0</span>
              </div>
              <div class="driver-stats s-neutral">
                <span v-if="driver.neutral_responses">{{driver.neutral_responses}}</span>
                <span v-else>0</span>
              </div>
              <div class="driver-stats s-positive">
                <span v-if="driver.positive_responses">{{driver.positive_responses}}</span>
                <span v-else>0</span>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row v-if="dashboardData.drivers_analysis" dense>
        <v-col>
          <div class="driver-range range-names">
            <div class="driver-stats s-negative">
              <span>Negative</span>
            </div>
            <div class="driver-stats s-neutral">
              <span class="">Neutral</span>
            </div>
            <div class="driver-stats s-positive">
              <span class="">Positive</span>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
    <div v-else class="am-no-data">
      {{noDataText}}
    </div>
  </div>
</template>

<script>
// import { tippy } from 'vue-tippy';

import OverviewMixin from './overview-mixin';

export default {
  name: 'driverOverview',

  // components: {
  //   tippy
  // },

  mixins: [OverviewMixin],

  methods: {
    viewDrivers () {
      // const queryParams = {
      //   ...this.$route.query
      // };
      // this.$router.push({
      //   path: '/drivers',
      //   query: queryParams
      // }).catch(() => {});
      const temp = {
        filters: {
          session__stage__title: this.$route.query && this.$route.query.stage ? [this.$route.query.stage] : undefined
        },
        stage__title__in: this.$route.query && this.$route.query.stage ? this.$route.query.stage : undefined,
        ...this.updateDashboardFilters
      };
      this.$router.push({
        path: '/drivers',
        query: {
          stage: this.$route.query && this.$route.query.stage ? this.$route.query.stage : undefined,
          // stage: this.$route.query && this.$route.query.stage ? this.$route.query.stage : undefined,
          // ...this.updateDashboardFilters
          filters: JSON.stringify(temp)
        }
      }).catch(() => {});
    },
    viewDriverCard (driver) {
      const temp = {
        stage__title__in: this.$route.query && this.$route.query.stage ? this.$route.query.stage : undefined,
        ...this.updateDashboardFilters
      };
      // console.log('temp', temp);
      this.$router.push({
        path: '/drivers/view',
        query: {
          driver,
          filters: JSON.stringify(temp)
        }
      }).catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.driver-overview-wrap {
  background: var(--bg);
  margin: 0;
  margin-top: 6px;
  padding: 16px;
  min-height: 24rem;
  border-radius: 6px;
  // box-shadow: 0 4px 20px 1px rgba(0,0,0,.06), 0 1px 4px rgba(0,0,0,.08) !important;
  box-shadow: 0 4px 16px 11px rgba(0, 0, 0, 0.06), 0 4px 8px rgba(0, 0, 0, 0.1) !important;
  .am-no-data {
    height: 15rem;
  }
  .wrap-title {
    padding: 8px 4px;
    // font-size: var(--content-size);
    font-size: 20px;
    color: var(--color-text);
  }
  .info-icon {
    padding: 10px 0px 0px 4px;
  }
  .driver-sub-wrap {
    padding-right: 12px;
    .driver-sub-text {
      padding: 8px 4px;
      font-size: var(--content-sub-size);
      color: var(--color-text);
    }
    .driver-action {
      white-space: nowrap;
      padding: 8px 4px;
      color: var(--primary-dark);
      cursor: pointer;
    }
  }
  .driver-overview-card {
    background: var(--bg);
    padding: 16px;
    text-align: center;
    height: 14rem;
    border-radius: 6px;
    // box-shadow: 0 4px 20px 1px rgba(0,0,0,.04), 0 1px 4px rgba(0,0,0,.06) !important;
    // border-radius: 11px;
    // background: #55b9f3;
    // box-shadow: 6px 6px 16px rgba(0, 0, 0, 0.04), -6px -6px 16px rgba(0, 0, 0, 0.06);
    box-shadow:
    // 3px 3px 12px 0 rgba(0, 0, 0, 0.06) inset,
    // -3px -3px 12px 0 rgba(0, 0, 0, 0.06) inset;
    3px 3px 9px 0 #ebe9ff inset,
    -3px -3px 9px 0 #ebe9ff inset;
    transition: 0.5s;
    -webkit-transition: 0.5s;
    box-shadow: 0 4px 16px 11px rgba(0, 0, 0, 0.06), 0 4px 8px rgba(0, 0, 0, 0.1) !important;
    &:hover {
      cursor: pointer;
      transform: scale(1.05);
      // box-shadow: 10px 10px 15px rgba(0,0,0,0.3);
    }
    .driver-title {
      margin: 6px 0 12px 0;
      font-size: var(--content-size);
      height: 4rem;
      color: var(--color-text);
    }
    .driver-score {
      font-size: var(--stats-size-1);
      color: var(--color-text);
      font-weight: var(--heading-weight);
    }
    .driver-footer {
      display: flex;
      justify-content: space-evenly;
      .driver-stats {
        // height: 25px;
        // min-width: 35px;
        padding: 4px 6px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        // color: var(--bg);
        color: var(--color-text);
        font-size: var(--content-sub-size);
        box-shadow:
        // 2px 2px 6px 0 rgba(0, 0, 0, 0.06),
        // -2px -2px 6px 0 rgba(0, 0, 0, 0.06);
        2px 2px 6px 0 #ebe9ff,
        -2px -2px 6px 0 #ebe9ff;
        &.s-negative {
          // background-color: var(--primary-color-2);
          background-color: rgba(244, 67, 54, 0.2);
        }
        &.s-neutral {
          // background-color: var(--primary-color-4);
          background-color: rgba(246, 251, 252, 0.2);
        }
        &.s-positive {
          // background-color: var(--primary-color-6);
          background-color: rgba(100, 231, 100, 0.2);
        }
      }
    }
  }
  .driver-range {
    display: flex;
    justify-content: space-evenly;
    .driver-stats {
      height: 25px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
      padding: 0 4px;
      color: var(--bg);
      font-size: var(--content-sub-size);
      &.s-negative {
        // background-color: var(--primary-color-2);
        background-color: rgba(244, 67, 54, 0.2);
      }
      &.s-neutral {
        // background-color: var(--primary-color-4);
        background-color: rgba(246, 251, 252, 1);
      }
      &.s-positive {
        // background-color: var(--primary-color-6);
        background-color: rgba(100, 231, 100, 0.2);
      }
    }
    &.range-names {
      justify-content: flex-end;
      .driver-stats {
        box-shadow:
        // 2px 2px 6px 0 rgba(0, 0, 0, 0.06),
        // -2px -2px 6px 0 rgba(0, 0, 0, 0.06);
        2px 2px 6px 0 #ebe9ff,
        -2px -2px 6px 0 #ebe9ff;
        color: var(--color-text);
        margin: 0 4px;
      }
    }
  }
}
</style>

<style lang="scss">
// .am-tool {
// .am-tool-btn {
//   background-color: red !important;
// }
// }
// .tippy-tooltip.dark-theme {
//   background-color: yellow !important;
// }
.tippy-tooltip.amara-theme {
  padding: 0 !important;
  // border: 2px solid orange;
  .tippy-content {
    padding: 16px;
    text-align: left;
    background-color: var(--bg) !important;
    color: var(--content-color);
  }
  .am-tool-btn {
    margin: 12px 0 0 0;
    display: flex;
    width: 100%;
    text-align: center;
    background-color: var(--primary-dark) !important;
    color: var(--bg) !important;
  }
}
</style>

<style scoped>
.driver-overview-card[min-width~="98px"] {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.driver-overview-card[min-width~="98px"] .driver-title {
  font-size: 14px;
}
.driver-overview-card[min-width~="120px"] .driver-title {
  font-size: 16px;
}
</style>
